export default "__VITE_ASSET__DFbJo8hB__"